/**
 * created by han guo qi
 * 发布视频的上传视频(本地上传)
 */
import React, {Component} from 'react';
import UploadWall from "../../../../components/upload/UploadWall";
import {VIDEO_TYPE} from "../../../../constants";
import {Scrollbars} from "react-custom-scrollbars";
import {Modal} from "antd";
import ChunkUpload from "../../../../components/upload/ChunkUpload";
import {rmtMessage} from "../../components/mess"
import BaseComponent from "../../../../base/BaseComponent";
import {Video} from "../../../resource/view/dialog/CurrencyResourceDialog";
class VideosLocally extends BaseComponent {

    static defaultProps = {
        maxSize: 120,  // 120MB
        limitDuration: true
    };

    constructor(props) {
        super(props);
        this.state = {
            fileList: [],
            pictureSize: '',
            widthAnd: "0",
            borderValue: '0',
            borderData: '0',
            status:true,
            viedMaxLength: this.sysConfigGetValueByKey("vied.max.length", "15"),
            muted:false,
            accept: "." + [...VIDEO_TYPE].join(",."),
        };
    }

    render() {
        return (
            <div>
                <Scrollbars style={{height:343}}>
                    <div style={{padding:10}}>
                        {this.upload("")}
                    </div>
                </Scrollbars>
                <Modal
                    maskClosable={false}
                    keyboard={true}
                    visible={this.state.previewVisible}
                    footer={null}
                    onCancel={() => this.setState({previewVisible: false,muted:true})}
                    width={520}
                    centered={true}
                >
                    <div style={{
                        display: 'flex',
                        alignItems: "center",
                        justifyContent: 'center',
                        paddingTop:20
                    }}>
                        {
                            <video style={{width:'100%'}} src={this.state.previewVideo} controls="controls" muted={this.state.muted} controlslist={"nodownload"}/>
                        }
                    </div>
                </Modal>
                <Video ref={ref => this.detailDialogVideo = ref} path={this.state.previewVideo}/>
            </div>
        )
    }


    beforeUpload = (file,fileList) => {
        return new Promise( (resolve, reject) => {
            let fileName = file.name.split('.');
            let ext = fileName.at(-1).toLowerCase();
            if(!VIDEO_TYPE.includes(ext)){
                rmtMessage.warning('暂不支持该视频类型！');
                reject();
                return;
            }
            if(file.size/1024/1024 > this.props.maxSize){
                rmtMessage.destroy();
                rmtMessage.warning(`暂不支持上传${this.props.maxSize}M以上的视频！`);
                return;
            }
            let fileurl = URL.createObjectURL(file);
            let video = document.createElement('video');
            video.src = fileurl;
            video.addEventListener('loadedmetadata', (e2)=> {
                let duration = video.duration;//视频时间
                if((duration / 60) > this.state.viedMaxLength && this.props.limitDuration){
                    rmtMessage.error('暂不支持上传15分钟以上的视频！');
                    reject();
                    return;
                }
                resolve(file);
            });
            video.addEventListener('error',(e)=>{
                rmtMessage.error('文件可能已损坏，请重新选择！');
                reject();
                return;
            })
        });

    };


    onChange = (info) => {
        let fileList = info.fileList.map(item => {
            // 取决于需要什么数据填入fileList
            if (item.uid === info.file.uid) {
                if (info.file.response && info.file.response.data) {
                    //分片上传是走的自己封装的接口 所以返回值只有data
                    //直接上传走的是antd的接口，所以返回值还有一个data属性包裹着的。这里主要是兼容两种返回值
                    info.file.response = {...info.file.response.data, ...info.file.response};
                }
                item.uid = info.file.uid;
                item.ext = info.file.response && info.file.response.suffix;
                item.url = info.file.response && info.file.response.thumbnailsPath;
                item.mp4Path = info.file.response && info.file.response.mp4Path;
                item.name = info.file.response && info.file.response.name;
                item.type = "video";
                item.isChunk = true;
                item.status = info.file.status;
                item.duration = info.file.response && info.file.response.duration;
                item.size = info.file.response && info.file.response.size;
                item.width= info.file.response && info.file.response.width;
                item.height= info.file.response && info.file.response.height;
                item.path = info.file.response && info.file.response.path;
            }
            return item;
        });

        let newFileLis = [fileList.at(-1)];
        newFileLis&&newFileLis.length&&newFileLis.forEach((item,index)=>{
            if(item.status==='error'){
                newFileLis.splice(index,1);
            }
        })
        this.props.onChange(JSON.parse(JSON.stringify(newFileLis)));
        this.setState({fileList: newFileLis});
    };

    handleRemove = file => {
        let fileList = this.state.fileList.filter(item => item.uid !== file.uid);
        this.props.onChange(JSON.parse(JSON.stringify(fileList)));
        this.setState({
            fileList
        });
    };

    handlePreview = file => {
        if (file && file.mp4Path) {
            this.setState({
                previewVideo: file.mp4Path + "?e=.mp4",
                // previewVisible: true,
                muted:false
            },() => {
                this.detailDialogVideo.show()
            });
        }
    };

    onDownload=file=>{

    if(file.path.indexOf("?") === -1){
         window.location.href = file.path + "?download=1";
       }else{
         window.location.href = file.path + "&download=1";
    }
    }

    upload(listType) {
        const {fileList,accept} = this.state;
        let array = JSON.parse(JSON.stringify(accept)).toLowerCase();
        let arr = array.split(",");
        let newArray = [];
        //打开弹框的时候  过滤掉重复的格式
        arr && arr.length && arr.forEach((item, index) => {
            if (newArray.indexOf(item) > -1) {
            } else {
                newArray.push(item)
            }
        });
        return (
            <div>
                <UploadWall
                    accept={newArray.toString()}
                    action="/storage/uploadFile"
                    listType={listType}
                    fileList={fileList}
                    style={{padding: 'unset'}}
                    multiple={false}
                    customRequest={new ChunkUpload({
                        checkFileURL: "/storage/checkFile",
                        checkChunkURL: "/storage/checkChunk",
                        uploadChunkURL: "/storage/uploadChunk",
                        chunkUploadOverURL: "/storage/chunkIsUploadOver",
                        mergeChunksURL: "/storage/mergeChunk",
                        fileError:(md5, mergeResult, newFile)=>{
                            Modal.error({
                                title: '上传错误！',
                                content: <div>文件  <span style={{color: 'red'}}>{mergeResult.name}</span>上传错误！</div>,
                                onOk: () => {
                                    let newFiles = fileList.filter(item=>item.md5 !== md5);
                                    this.setState({fileList: newFiles})
                                }
                            });
                        }
                    }).start}
                    icons={["play", "download", "delete"]}
                    uploadBtnName={"点击上传"}
                    beforeUpload={async (file,fileList)=>{
                        return await this.beforeUpload(file,fileList)
                    }}
                    onDownload={this.onDownload}
                    onChange={this.onChange}
                    onRemove={this.handleRemove}
                    onPlay={this.handlePreview}
                />
            </div>
        )
    }


}

VideosLocally.propTypes = {};

export default VideosLocally;
